import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import React, { Component } from "react"
import Wrapper from "../../../components/Common/Wrapper"
import CustomAlert from '../../../components/CustomAlert'
import ScheduleTable from "../../../components/Table/ScheduleTable"
import rebase from "../../../config/rebase"
import { dbPrefix, knowledgeAreaArray } from "../../../Constants"
import { countReportsByReviewer, createEmptyReports, getAllReviewers, getReportsForKA, getReportsForPaper } from "../../../rebaseService"

class SendReviews extends Component {

  state = {
    loaded: false,
    knowledgeArea: '',
    allPapers: [],
    selectedKAPapers: [],
    papersMissingReportsKA: [],
    reportsFromSelectedKA: [],
    reviewersFromSelectedKA: [],
    reports: [],
    toClosePapersKA: [],
    coiPapersKA: [],
    reportsByReviewer: [],
    avaliablePapersKA: [],
  }

  columnsReportsPerReviewer = [
    {
      name: "reviewer",
      label: "Revisor",
    },
    {
      name: "openReportCount",
      label: "Avaliações abertas",
    },
    {
      name: "coiReportCount",
      label: "Availações com conflito de interesse",
    },
    {
      name: "finishedReportCount",
      label: "Avaliações finalizadas",
    },
  ];


  columnsReviews = [
    {
      name: "paper",
      label: "Título",
      options: {
        filter: true,
        customBodyRender: (val) => {
          const paperTitle = this.state.allPapers.find(p => p.key === val).paperTitle
          return <span>{paperTitle}</span>
        }
      }
    },
    {
      name: "reviewer",
      label: "Revisor",
      options: {
        filter: true
      }
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true
      }
    },
    {
      name: "knowledgeArea",
      label: "Área de Conhecimento",
      options: {
        filter: true
      }
    },
    {
      name: "accepted",
      label: "Aceito?",
    },
    {
      name: "comment",
      label: "Comentário",
    },
    {
      name: "observation",
      label: "Observação",
    },
  ];
  columnsMissing = [
    {
      name: "paperTitle",
      label: "Nome",
      options: {
        filter: true
      }
    },
    {
      name: "toGenerate",
      label: "Quantidade de Avaliações Faltantes",
      options: {
        filter: true
      }
    },
    {
      name: "knowledgeArea",
      label: "Área de Conhecimento",
      options: {
        filter: true
      }
    },
  ];
  columns = [
    {
      name: "paperTitle",
      label: "Nome",
      options: {
        filter: true
      }
    },
    {
      name: "knowledgeArea",
      label: "Área de Conhecimento",
      options: {
        filter: true
      }
    },
  ];

  async componentDidMount() {
    try {
      this.setState({ loaded: false })
      let allPapers = await rebase.fetch(dbPrefix + 'papers', {
        asArray: true
      })
      this.setState({ allPapers })
    } catch (e) {
      console.log(e)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }
    finally {
      this.setState({ loaded: true })
    }
  }

  async handleKAChange(e) {
    try {
      let ka = e.target.value
      let selectedKAPapers = this.state.allPapers.filter(p => p.knowledgeArea === ka)
      await this.setState({ knowledgeArea: ka, selectedKAPapers })
      await this.getReviewersAndReportsFromKA()
      await this.countReportsByPaper()
    } catch (error) {
      console.log(error)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }
    finally {
      this.setState({ loaded: true })
    }
  }

  async countReportsByPaper() {
    // 1. Buscar papers
    // 2. Buscar reports por paper 
    // 3. Contar reports por avaliad
    try {
      let finishedPapers = []
      let toClosePapersKA = []
      let coiPapersKA = []
      let papersMissingReportsKA = []
      //     1. Separar os finished 
      for (let paper of this.state.selectedKAPapers) {
        let reports = await getReportsForPaper(paper.knowledgeArea, paper.key)
        paper.reports = reports
        if (paper.status === 'finished') {
          finishedPapers.push(paper)
        } else {
          // 2. Verifica se já tem 2 reports completos
          if (reports.filter(el => el.status === 'finished').length >= 2) {
            toClosePapersKA.push(paper)
          } else {
            // 3. Se chegar aqui, significa que:
            // não tem 2 reports positivos
            // pode ter um ou mais cois
            let coiReports = reports.filter(r => r.status === 'coi')
            if (coiReports.length > 0) {
              coiPapersKA.push(paper)
            }
            let openReports = reports.filter(r => r.status === 'open')
            let finishedReports = reports.filter(r => r.status === 'finished')
            let toGenerate = 2 - finishedReports.length - openReports.length
            paper.toGenerate = toGenerate
            if (toGenerate > 0) {
              papersMissingReportsKA.push(paper)
            }
          }
        }
      }
      this.setState({ papersAndItsReports: [...finishedPapers, ...toClosePapersKA, ...coiPapersKA, ...papersMissingReportsKA] })
      this.setState({ coiPapersKA, toClosePapersKA, finishedPapers, papersMissingReportsKA })

    } catch (e) {
      console.log(e)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }

  }

  async getReviewersAndReportsFromKA() {
    try {
      let reviewersFromSelectedKA = await getAllReviewers(this.state.knowledgeArea)
      let reportsFromSelectedKA = await getReportsForKA(this.state.knowledgeArea)
      let reportsByReviewer = await countReportsByReviewer(reportsFromSelectedKA, reviewersFromSelectedKA)

      await this.setState({ reviewersFromSelectedKA, reportsByReviewer, reportsFromSelectedKA })
    } catch (e) {
      console.log(e)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }

  }


  async sendNewPapersForReviewers() {
    try {
      this.setState({ loaded: false })
      // se o paper não tiver revisão, distribui para dois revisores
      for (let p of this.state.papersMissingReportsKA) {
        if (this.state.reportsFromSelectedKA.length === 0) {
          await createEmptyReports(this.state.reportsByReviewer[0].reviewer, p)
          await createEmptyReports(this.state.reportsByReviewer[1].reviewer, p)
          await this.getReviewersAndReportsFromKA()
          await this.countReportsByPaper()
        } else {
          let i = p.toGenerate
          for (let k = 0; k < i; k++) {
            // o paper tiver conflito de interesses
            let coiPaper = this.state.coiPapersKA.find(coi => coi.key === p.key)
            if (coiPaper) {
              // se tiver conflito de interesses, distribui para os revisores disponíveis que não estão na lista de conflito de interesses
              // e nem na lista de revisores que já fizeram a revisão
              let jaAvaliaram = p.reports.map(r => r.reviewer)
              let availableReviewers = this.state.reportsByReviewer.filter(r => r.reviewer != jaAvaliaram.find(e => e == r.reviewer))
              console.log(availableReviewers);
              await createEmptyReports(availableReviewers[0].reviewer, p)
              await this.getReviewersAndReportsFromKA()
              await this.countReportsByPaper()
            } else {
              // se não tiver conflito de interesses, distribui para os revisores disponíveis
              // pegando do menos ocupado para o mais ocupado
              // que já vem ordenado do countReportsByPaper()
              console.log(this.state.reportsByReviewer);

              await createEmptyReports(this.state.reportsByReviewer[0].reviewer, p)
              await this.getReviewersAndReportsFromKA()
              await this.countReportsByPaper()
            }
          }
        }
      }
    } catch (e) {
      console.log(e)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }
    finally {
      this.setState({ loaded: true })
    }
  }

  handleClick() {
    this.props.history.push(`/admin/finalizacao`)
  }

  render() {

    return (
      <Wrapper loaded={this.state.loaded} fatalError={this.state.fatalError} currentPath={this.props.location.pathname} adminTopbar>
        <br />
        <br />
        <FormControl
          variant="outlined"
        >
          <Select
            id="knowledgeArea"
            name="knowledgeArea"
            value={this.state.knowledgeArea}
            onChange={this.handleKAChange.bind(this)}
            placeholder="Selecione uma Área de Conhecimento"
          >
            {
              knowledgeAreaArray.map(k => (
                <MenuItem key={k.value} value={k.value}>{k.title}</MenuItem>
              ))
            }
          </Select>
          <FormHelperText id="knowledgeArea">Área de Conhecimento</FormHelperText>
        </FormControl>
        <br />
        {
          this.state.knowledgeArea &&
          <>
            {
              this.state.reviewersFromSelectedKA.length > 0 ?
                <CustomAlert message={"Avaliadores disponíveis: " + this.state.reviewersFromSelectedKA.join(', ')} />
                :
                <CustomAlert message={"Não há avaliadores disponíveis"} />
            }
            <br /><br />
            {
              this.state.reportsByReviewer.length > 0 ?
                <ScheduleTable data={this.state.reportsByReviewer} columns={this.columnsReportsPerReviewer} title={"Avaliações por avaliador"} />
                :
                <CustomAlert message={"Não há avaliações por avaliador"} />
            }
            <br /><br />
            {
              this.state.reportsFromSelectedKA.length > 0 ?
                <ScheduleTable data={this.state.reportsFromSelectedKA} columns={this.columnsReviews} title={"Avaliações"} />
                :
                <>
                  <CustomAlert message={"Não há avaliações para esta área de conhecimento"} />
                </>
            }
            <br /><br />
            {
              this.state.papersMissingReportsKA.length > 0 ?
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.sendNewPapersForReviewers.bind(this)}>Distribuir trabalhos sem revisão para avaliadores</Button>
                  <ScheduleTable data={this.state.papersMissingReportsKA} columns={this.columnsMissing} title={"Trabalhos sem revisão"} />
                </>
                :
                <CustomAlert message={"Todos os trabalhos já foram enviados para revisão"} />
            }
            <br /><br />
            {
              this.state.toClosePapersKA.length > 0 ?
                <ScheduleTable data={this.state.toClosePapersKA} columns={this.columns} title={"Trabalhos para encerrar"} />
                :
                <CustomAlert message={"Não há trabalhos para encerrar"} />
            }
            <br /><br />
            {
              this.state.coiPapersKA.length > 0 ?
                <ScheduleTable data={this.state.coiPapersKA} columns={this.columns} title={"Trabalhos com conflito de interesse"} />
                :
                <CustomAlert message={"Não há trabalhos com conflito de interesse"} />
            }
            <br /><br />
          </>
        }
      </Wrapper>
    )
  }
}

export default SendReviews
